import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isChecked: true,
    pageerror: '',
    fielderror: '',
    selectedDocType: '',
    docTypeNumber: '',
    isDocNumValid: false,
    isUploadModalOpen: false,
    fileerror: null,
    fileData: null,
    fileSuccess: null,
    isUpdating: false
};

const businessSlice = createSlice({
    name: 'business',
    initialState,
    reducers: {
        setIsChecked(state, action) {
            state.isChecked = action.payload;
        },
        setPageError(state, action) {
            state.pageerror = action.payload;
        },
        setFieldError(state, action) {
            state.fielderror = action.payload;
        },
        setEmailAddress(state, action) {
            state.emailAddress = action.payload;
        },
        setSelectedDocType(state, action) {
            state.selectedDocType = action.payload;
        },
        setSelectedDocTypeNumber(state, action) {
            state.docTypeNumber = action.payload;
        },
        setDocNumValid(state, action) {
            state.isDocNumValid = action.payload;
        },
        openUploadModal: (state) => {
            state.isUploadModalOpen = true;
        },
        closeUploadModal: (state) => {
            state.isUploadModalOpen = false;
        },
        setFileError: (state, action) => {
          state.fileerror = action.payload;
        },
        setFileData: (state, action) => {
          state.fileData = action.payload;
        },
        setFileSuccess: (state, action) => {
          state.fileSuccess = action.payload;
        },
        setIsUpdating: (state, action) => {
          state.isUpdating = action.payload;
        },
    },
});

export const { setIsChecked, setPageError, setFieldError, setEmailAddress, setSelectedDocType, setSelectedDocTypeNumber, setDocNumValid, openUploadModal, closeUploadModal, setFileError, setFileData, setFileSuccess, setIsUpdating } = businessSlice.actions;

export default businessSlice.reducer;
